/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../utils/config';

export const GET_KPIS_URL = `${API_URL}/noc_ticket/kpi`;
